import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginAndUserManagerService } from '../../api/managers/login-and-user-manager.service';
import { LoggingService } from '../../services/logging.service';

@Injectable()
export class AdminGuardService implements CanActivate, CanActivateChild, CanLoad
{
    constructor(private userManagerService: LoginAndUserManagerService,
                private router: Router)
    {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
    {
        LoggingService.log('AdminGuard: CanActivate()');
        return this.isAdministrator();
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
    {
        LoggingService.log('AdminGuard: CanActivateChild()');
        return this.isAdministrator();
    }

    canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean
    {
        LoggingService.log('AdminGuard: CanLoad()');
        return this.isAdministrator();
    }

    private isAdministrator()
    {
        const isAdministrator = this.userManagerService.currentUser && this.userManagerService.currentUser.IsToroAdministrator;
        if (!isAdministrator)
        {
            this.router.navigate(['/dashboard']);
        }
        return isAdministrator;
    }

}
